/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { LeaveType } from 'app/shared/model/enumerations/leave-type.model';
import { createEntity, getEntity, reset, updateEntity } from './day-off.reducer';

export const DayOffUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nurses = useAppSelector(state => state.nurse.entities);
  const dayOffEntity = useAppSelector(state => state.dayOff.entity);
  const loading = useAppSelector(state => state.dayOff.loading);
  const updating = useAppSelector(state => state.dayOff.updating);
  const updateSuccess = useAppSelector(state => state.dayOff.updateSuccess);
  const leaveTypeValues = Object.keys(LeaveType);

  const handleClose = () => {
    navigate(`/day-off${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...dayOffEntity,
      ...values,
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          type: 'CASUAL_LEAVE',
          ...dayOffEntity,
          nurse: dayOffEntity?.nurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dayOff.home.createOrEditLabel" data-cy="DayOffCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dayOff.home.createOrEditLabel">Create or edit a DayOff</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="day-off-id"
                  label={translate('tinyMedicRestApp.dayOff.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dayOff.requestedDate')}
                id="day-off-requestedDate"
                name="requestedDate"
                data-cy="requestedDate"
                type="date"
              />
              <ValidatedField label={translate('tinyMedicRestApp.dayOff.type')} id="day-off-type" name="type" data-cy="type" type="select">
                {leaveTypeValues.map(leaveType => (
                  <option value={leaveType} key={leaveType}>
                    {translate(`tinyMedicRestApp.LeaveType.${leaveType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dayOff.active')}
                id="day-off-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dayOff.cursor')}
                id="day-off-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dayOff.lastUpdate')}
                id="day-off-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dayOff.microSec')}
                id="day-off-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dayOff.timestampEntry')}
                id="day-off-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="day-off-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.dayOff.nurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/day-off" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DayOffUpdate;
